import { render } from "./opColorPicker.vue?vue&type=template&id=20e10898&scoped=true&ts=true"
import script from "./opColorPicker.vue?vue&type=script&lang=ts"
export * from "./opColorPicker.vue?vue&type=script&lang=ts"

import "./opColorPicker.vue?vue&type=style&index=0&id=20e10898&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e10898"]])

export default __exports__